export const UI_PORT = 4007;
export const CONTEXT_PATH = '/console';
export const API_PATH = ' ';
export const API_URL = API_PATH;
export const ENV_NAME = 'DEV';
export const STRIPE_PK = 'pk_test_51HtxPEGYFZZN9l0lfy51NuKJquVbsIb0rp6KsQz23x6XV7OrgTSncpFRaXQQ5Pm8J7EYYk5IN1CTEGorYfIQ2zt200xYUwPAvH';

export const BUILD_TAG = 'master';

export const BUILD_DATE = 'Mon Apr 20 07:09:16 UTC 2026';

export const BUILD_COMMIT = 'ca4458da40a9987f019211197cd2f583b0332525';
